(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bonhomia-gift-wrap"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bonhomia-gift-wrap')) {
    customElements.define('bonhomia-gift-wrap', class extends HTMLElement {
      connectedCallback() {
        const checkbox = this.querySelector('[data-gift-wrap]');
        checkbox.disabled = false;
        checkbox.addEventListener('change', () => {
          this.closest('form').classList.toggle('bonhomia-wrap-selected', checkbox.checked);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
